import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text } from 'components/ui';
import Icon from 'components/Icon';

const DELIVERY_TYPES = {
    BOPIS: 'bopis',
    GIS: 'gis',
    SDD: 'sdd'
};

const getEmptyStateCopyKeys = deliveryType => {
    if (deliveryType === DELIVERY_TYPES.BOPIS || deliveryType === DELIVERY_TYPES.SDD) {
        return { prefixKey: 'bopisEmptyStatePrefix', boldKey: 'bopisEmptyStateBold' };
    }

    return { prefixKey: 'gisEmptyStatePrefix', boldKey: 'gisEmptyStateBold' };
};

const EmptyStatePrompt = ({ onClick, getText, deliveryType }) => {
    const { prefixKey, boldKey } = getEmptyStateCopyKeys(deliveryType);

    return (
        <Text
            is='button'
            type='button'
            lineHeight='tight'
            fontSize='sm'
            onClick={onClick}
        >
            {getText(prefixKey)}
            <Text
                is='span'
                fontWeight='bold'
                children={getText(boldKey)}
            />
            <Icon
                name='caretDown'
                size={12}
                marginLeft={1}
            />
        </Text>
    );
};

EmptyStatePrompt.propTypes = {
    onClick: PropTypes.func.isRequired,
    getText: PropTypes.func.isRequired,
    deliveryType: PropTypes.oneOf([DELIVERY_TYPES.BOPIS, DELIVERY_TYPES.GIS, DELIVERY_TYPES.SDD]).isRequired
};

export default wrapFunctionalComponent(EmptyStatePrompt, 'EmptyStatePrompt');
